import React, { Component } from 'react';
import './AutodiagnosticoForm.css';

export class AutodiagnosticoContentPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cuestionario: props.cuestionario
        };
        this.input_onCheck = this.input_onCheck.bind(this);
        this.input_onChange = this.input_onChange.bind(this);
    }
    input_onCheck(event) {
        let name = event.target.name;
        if (event.target.checked) {
            this.props.cuestionario.preguntas[name].respuesta = 'Si';
        } else {
            this.props.cuestionario.preguntas[name].respuesta = 'No';
        }
    }
    input_onChange(event) {
        let name = event.target.name;
        this.props.cuestionario.preguntas[name].respuesta = '' + event.target.value;
    }
    obtenerCuestionarioDiligenciado() {
        var i = 0;
    }
    crearInput(item, index) {
        if (item.tipo == 0) {
            if (item.opciones.length == 2) {
                if (item.opciones[0] == 'Si' && item.opciones[1] == 'No') {
                    this.props.cuestionario.preguntas[index].respuesta = 'No';
                    return <input key={item.id} name={index} type="checkbox" onClick={this.input_onCheck} />
                }
            }
            if (item.opciones.length > 0) {
                this.props.cuestionario.preguntas[index].respuesta = item.opciones[0];
            }
            return <select key={item.id} name={index} onChange={this.input_onChange} class="form-control form-control-sm">
                {
                    item.opciones.map((opcion) => (
                        <option value={opcion}>{opcion}</option>
                    ))
                }
            </select>
        } else {
            return <input key={item.id} name={index} type="text" onChange={this.input_onChange} />
        }
    }
    render() {
        return (
            <div className="autodiagnostico-contenedor">
                <table>
                    {
                        this.props.cuestionario.preguntas.map((item, index) => (
                            <tr>
                                <td className="td-label">
                                    {item.enunciado}
                                </td>
                                <td className="td-input">
                                    {this.crearInput(item, index)}
                                </td>
                            </tr>
                        ))
                    }
                </table>
            </div>
        );
    }
}

